import { createContext, useContext } from 'react';

import type { MenuItem } from './typing';

const ActiveMenuItemContext = createContext<MenuItem>({} as MenuItem);

export const useActiveMenuItem = (): MenuItem => useContext(ActiveMenuItemContext);

export const ActiveMenuItemProvider = ActiveMenuItemContext.Provider;
